import Vue from 'vue/dist/vue.js';
import flatPickr from 'vue-flatpickr-component';
import {Norwegian} from 'flatpickr/dist/l10n/no.js';


export default {

    init() {
        this._container = document.getElementById('formreport');
        
        if (!this._container) {
            return;
        }
        
        new Vue({
            el        : this._container,
            delimiters: ['[[', ']]'],
            data : {
                entries :null,
                entrySelected :null,
                sections : null,
                sectionSelected : null,
                forms : null,
                formSelected : null,
                reportText : null,
                date: null,
                fullreport: null,
                button: null,
                config: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'M j, Y',
                    mode: "range",
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: Norwegian
                },
            },
            components: {
                'flatPickr':flatPickr
            },

            created() {
                this.getSections();
            },

            // componets:[this.sectionSelected],

            methods:{
                getSections: function () {
                    this.forms = null;
                    this.entries = null;

                    let url = "/actions/formiesupport/report/get-sections";
                    fetch(url)
                    .then((response) => {
                        return response.json();
                    })
                    .then(data => {
                        this.sections = data;
                      })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                },
                getEntries: function(e)
                {
                    // console.log(typeof this.sectionSelected);
                    // console.log(this.sectionSelected);

                    let selected = (typeof this.sectionSelected === 'number') ?
                        this.sectionSelected :
                        this.sectionSelected.split("--")[0]; // scary legacy code, looks deprecated but not for sure :-)

                    this.forms = null;
                    this.entries = null;
                    
                    let url = "/actions/formiesupport/report/get-entries?";
                    fetch(url + new URLSearchParams({
                        section : selected,
                    }))
                    .then((response) => {
                        return response.json();
                    })
                    .then(data => {
                        this.entries = data;
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                    
                },
                getForms: function(e){
                    let selected = this.entrySelected;
                    this.reportText = null;

                    let url = "/actions/formiesupport/report/get-forms?";
                    fetch(url + new URLSearchParams({
                        entry : selected,
                    }))
                    .then((response) => {
                        return response.json();
                    })
                    .then(data => {
                        this.forms = data;
                        if(this.form ==  null){
                            this.button = false;
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                },
                showBtn : function(e){
                    this.button = true;
                    let selected = e.target.value;
                    this.formSelected = selected;
                },
                getReport: function(e){
                    this.reportText = null;
                    let url = "/actions/formiesupport/report/get-report?";
                    fetch(url + new URLSearchParams({
                        entry : this.entrySelected,
                        form : this.formSelected,
                        date : this.date,
                        fullreport : this.fullreport
                    }))
                    .then((response) => {
                        return response.text();
                    })
                    .then(data => {
                       if(data){
                           let a = document.createElement("a");
                           a.href = data;
                           a.download = data.split('/').pop();
                           a.click();
                           this.reportText =  {'success':'Filen er lastet ned'};
                        }else{
                            this.reportText = {'error': 'Ingen påmeldinger'};
                        }
                    })
                    .catch((error) => {
                        console.log('Error:', error);
                    });
                        
                }
            },
           
                
        });
    }
}